<EIPDateRangePicker #dateRangePicker [IsSelectionRequired]=true [setId]="getId()" [WaterMark]="getWaterMark()"
    (selectedStartDate)='setStartDateValue($event)' (selectedEndDate)='setEndDateValue($event)' [valueStart]="startDate"
    [valueEnd]="endDate" placeholder="Select Date Range" [ShowClearIcon]="true" (click)="closedate($event,$event)">
</EIPDateRangePicker>